import { render, staticRenderFns } from "./invest_money.vue?vue&type=template&id=14867f4f&scoped=true&"
import script from "./invest_money.vue?vue&type=script&lang=js&"
export * from "./invest_money.vue?vue&type=script&lang=js&"
import style0 from "./invest_money.vue?vue&type=style&index=0&id=14867f4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14867f4f",
  null
  
)

export default component.exports